import { render, staticRenderFns } from "./OfflineDownloads.vue?vue&type=template&id=52bea486&scoped=true&"
import script from "./OfflineDownloads.vue?vue&type=script&lang=ts&"
export * from "./OfflineDownloads.vue?vue&type=script&lang=ts&"
import style0 from "./OfflineDownloads.vue?vue&type=style&index=0&id=52bea486&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bea486",
  null
  
)

export default component.exports